














































































































import InitialShowState from "@/models/InitialShowState";
import { Mutations } from "@/store/mutations";
import Vue from "vue";
import FileModal from "./FileModal.vue";
import LoadModal from "./LoadModal.vue";

/**
 * Contains menus and options that control the application's state
 */
export default Vue.extend({
  name: "MenuTop",
  components: {
    FileModal,
    LoadModal,
  },
  data: () => ({
    fileModalActive: false,
    loadModalActive: false,
  }),
  computed: {
    showTitle(): string {
      return this.$store.getters.getShowTitle;
    },

    fourStepGrid: {
      get(): boolean {
        return this.$store.state.fourStepGrid;
      },
      set(enabled: boolean): void {
        this.$store.commit(Mutations.SET_FOUR_STEP_GRID, enabled);
      },
    },

    yardlines: {
      get(): boolean {
        return this.$store.state.yardlines;
      },
      set(enabled: boolean): void {
        this.$store.commit(Mutations.SET_YARDLINES, enabled);
      },
    },

    yardlineNumbers: {
      get(): boolean {
        return this.$store.state.yardlineNumbers;
      },
      set(enabled: boolean): void {
        this.$store.commit(Mutations.SET_YARDLINE_NUMBERS, enabled);
      },
    },

    showDotLabels: {
      get(): boolean {
        return this.$store.state.showDotLabels;
      },
      set(enabled: boolean): void {
        this.$store.commit(Mutations.SET_SHOW_DOT_LABELS, enabled);
      },
    },

    showField: {
      get(): boolean {
        return this.$store.state.showField;
      },
      set(enabled: boolean): void {
        this.$store.commit(Mutations.SET_SHOW_FIELD, enabled);
      },
    },

    fileURL(): string {
      const jsonData = JSON.stringify(this.$store.state.show);
      const blob = new Blob([jsonData], { type: "text/plain;charset=utf-8;" });
      return URL.createObjectURL(blob);
    },
    undoName(): string {
      return this.$store.getters.getUndoName;
    },
    redoName(): string {
      return this.$store.getters.getRedoName;
    },
  },
  methods: {
    undo(): void {
      this.$store.commit(Mutations.UNDO);
    },
    redo(): void {
      this.$store.commit(Mutations.REDO);
    },
    newShow(): void {
      this.$store.commit(Mutations.SET_NEW_SHOW, new InitialShowState());
    },
  },
});
